module.exports = __webpack_public_path__ + "img/smokyscarlet_back.b331ddb3.jpg";